import React from 'react';
import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';
import CardsSection from '../CardsSection';
import Card from '../Card';

import styles from './CashFundDiscountCardsSection.module.less';

const CashFundDiscountCardsSection: React.FC = (): JSX.Element => (
  <CardsSection>
    <Card
      className={styles.lowestCashFundContainer}
      title={<>Zero-fee cash funds</>}
      dek="Yes, really. It’s now easier than ever to create a fund for that new puppy or honeymoon."
      footer={
        <LinkV2
          href="/faq/115002836332-how-do-we-choose-who-covers-the-2-5-credit-card-processing-fee-for-cash-gifts"
          className="card__footer"
          rel="noreferrer noopener"
          arrow
        >
          Learn More
        </LinkV2>
      }
    />
    <Card
      className={styles.postWeddingCardContainer}
      title={<span className={styles.plumText}>20% Post-Wedding Discount</span>}
      dek={
        <span className={styles.plumText}>
          The best deal out there. Period. Use it as many times as you want for six months after “I
          do.”
        </span>
      }
      footer={
        <LinkV2
          href="/faq/115002837692-does-zola-offer-a-post-wedding-or-completion-discount-"
          className="card__footer"
          rel="noreferrer noopener"
          arrow
        >
          Get The Scoop
        </LinkV2>
      }
    />
  </CardsSection>
);

export default CashFundDiscountCardsSection;
